
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";

@Component({
    components: {},
})
export default class MobileFilterModal extends Vue {
    @Inject("container") readonly container!: Container;
    @Prop() filterStore!: any;
}
